import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// routes
import Home from '../components/Home'
import OurStory from '../components/OurStory'
import OurTeam from '../components/OurTeam'
import PrivacyPolicy from '../components/PrivacyPolicy'
import Gallery from '../components/Gallery'

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/our-story', component: OurStory, meta: { title: 'Our Story' } },
  { path: '/our-team', component: OurTeam, meta: { title: 'Our Team' } },
  { path: '/privacy-policy', component: PrivacyPolicy, meta: { title: 'Privacy Policy' } },
  { path: '/gallery', component: Gallery, meta: { title: 'Gallery' } },
  { path: '/donate', redirect: { name: 'Home', hash: '#donate' } },
  { path: '/events', redirect: { name: 'Home', hash: '#events' } },
  { path: '/contact', redirect: { name: 'Home', hash: '#contact' } }
]

export default new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return { x: 0, y: 0 }
    }
  },
  beforeEach (to, from, next) {
    let title = 'Pencils for Kids, Inc.'
    if (to.meta.title) {
      title = to.meta.title + ' | ' + title
    }
    document.title = title
    next()
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js